import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "icon" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "description" }

import AppIcon from '@/components/common/app-icon/AppIcon.vue';
import { IconName, IconSize } from '@/models/icon-types';

interface Props {
  title: string;
  description?: string | null;
  iconName?: IconName;
  iconSize?: IconSize;
  clickable: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SourceComponent',
  props: {
    title: {},
    description: { default: null },
    iconName: { default: IconName.Document },
    iconSize: { default: IconSize.HeadlineM },
    clickable: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'source-component': true,
      'clickable-card': props.clickable
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AppIcon, {
        name: _ctx.iconName,
        size: _ctx.iconSize
      }, null, 8, ["name", "size"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", null, _toDisplayString(_ctx.title), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.description), 1)
    ])
  ], 2))
}
}

})